import fetch from '@adc/fetch';
export const getBiddingStatus = (req, opts = { listingId: null }) => fetch
    .fromService('RESI_MS_ONLINE_AUCTION')
    .get(`/resi/online-auction/v1/legacy-bidding/listings/${opts.listingId}/bid-status`, { req })
    .then(({ body }) => body);
export const getBiddingHistory = (req, opts = {}) => {
    const mergedOpts = { ...{ listingId: null, size: '3' }, ...opts };
    return fetch
        .fromService('RESI_MS_ONLINE_AUCTION')
        .get(`/resi/online-auction/v1/legacy-bidding/listings/${mergedOpts.listingId}/bids`, { req, queryParams: { size: mergedOpts.size } })
        .then(({ body }) => body);
};
export const getBiddingPreAuctionDates = (req, opts = { listingId: null }) => fetch
    .fromService('RESI_MS_ONLINE_AUCTION')
    .get(`/resi/online-auction/v1/legacy-bidding/listings/${opts.listingId}/pre-auction-dates`, { req })
    .then(({ body }) => body);
export const performBid = (req, opts = {}) => {
    const mergedOpts = {
        ...{ listingId: null, bid: { bid_amount: null } },
        ...opts,
    };
    return fetch
        .fromService('RESI_MS_ONLINE_AUCTION')
        .post(`/resi/online-auction/v1/legacy-bidding/listings/${mergedOpts.listingId}/bids`, {
        body: mergedOpts.bid,
    })
        .then(({ body }) => body);
};
export const performProxyBid = (req, opts = {}) => {
    const mergedOpts = {
        ...{ listingId: null, bid: { bid_amount: null } },
        ...opts,
    };
    return fetch
        .fromService('RESI_MS_ONLINE_AUCTION')
        .post(`/resi/online-auction/v1/legacy-bidding/listings/${mergedOpts.listingId}/max-bids`, {
        body: mergedOpts.bid,
    })
        .then(({ body }) => body);
};
export const getBiddingStatusCollection = (req, opts = { listingIds: [] }) => fetch
    .fromService('RESI_MS_ONLINE_AUCTION')
    .post('/resi/online-auction/v1/legacy-bidding/listings/list/bid-status', {
    body: { listing_ids: opts.listingIds },
    req,
})
    .then(({ body }) => body);
//# sourceMappingURL=bidding.js.map